import { PiWarningCircleFill } from "react-icons/pi";
import { useCurrenRatio } from "../../utils";
import { CardSection } from "../CardSection";
import { Card, MultipleChart, MultipleChartData, Toggle } from "components";
import { useState } from "react";
import { CurrentRatioType, DebtRatioType, EquityRatioType, NetWorthType, WorkingCapitalType } from "../../types";

export function FinancialRatio(props: {
    location_id?: string,
    month?: string | undefined,
    year?: string | undefined
}) {

    const [isShow, setIsShow] = useState(true)
    const [chartType, setChartType] = useState<"line" | "bar">("line")

    const { data: currenRatio } = useCurrenRatio({
        date: `${props.year}${props.month}`,
        location_id: props.location_id,
        type: "current_ratio"
    })

    const { data: debtRatio } = useCurrenRatio({
        date: `${props.year}${props.month}`,
        location_id: props.location_id,
        type: "debt_ratio"
    })

    const { data: workingCapital } = useCurrenRatio({
        date: `${props.year}${props.month}`,
        location_id: props.location_id,
        type: "working_capital"
    })

    const { data: netWorth } = useCurrenRatio({
        date: `${props.year}${props.month}`,
        location_id: props.location_id,
        type: "net_worth"
    })

    const { data: equityRatio } = useCurrenRatio({
        date: `${props.year}${props.month}`,
        location_id: props.location_id,
        type: "equity_ratio"
    })

    


    return (
        <section>
            {isShow && (
                <>
                    <div className="flex items-center justify-between">
                        <div className="font-bold text-[15px] mr-2">Financial ratio</div>
                        <div>
                            <MultipleChart.Dropdown
                                value={chartType}
                                onChange={(type) => setChartType(type)}
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-2 lg:grid-cols-3 mt-2 gap-2 h-full">

                        <RatioSection
                            label={currenRatio?.data.map((item) => item.location_name)}
                            value={currenRatio?.data.map((item) => ("current_ratio" in item ? item.current_ratio : 0))}
                            title="CURRENT RATIO"
                            valueTitle={Number((currenRatio as CurrentRatioType)?.current_ratio || 0)}
                            chartType={chartType}
                        />

                        <RatioSection
                            label={debtRatio?.data.map((item) => item.location_name)}
                            value={debtRatio?.data.map((item) => ("debt_ratio" in item ? item.debt_ratio : 0))}
                            title="DEBT RATIO"
                            valueTitle={Number((debtRatio as DebtRatioType)?.debt_ratio || 0)}
                            chartType={chartType}
                        />

                        <RatioSection
                            label={netWorth?.data.map((item) => item.location_name)}
                            value={netWorth?.data.map((item) => ("net_worth_ratio" in item ? item.net_worth_ratio : 0))}
                            title="CURRENT LIABILITIES TO NET WORTH"
                            valueTitle={Number((netWorth as NetWorthType)?.net_worth_ratio || 0)}
                            chartType={chartType}
                        />

                        <RatioSection
                            label={equityRatio?.data.map((item) => item.location_name)}
                            value={equityRatio?.data.map((item) => ("debt_to_equity_ratio" in item ? item.debt_to_equity_ratio : 0))}
                            title="DEBT TO EQUITY RATIO"
                            valueTitle={Number((equityRatio as EquityRatioType)?.debt_to_equity_ratio || 0)}
                            chartType={chartType}
                        />

                        <RatioSection
                            label={workingCapital?.data.map((item) => item.location_name)}
                            value={workingCapital?.data.map((item) => ("working_capital" in item ? item.working_capital : 0))}
                            title="WORKING CAPITAL TO TOTAL ASSET"
                            valueTitle={Number((workingCapital as WorkingCapitalType)?.working_capital || 0)}
                            chartType={chartType}
                        />

                    </div>
                </>
            )}

            <div>
                <div className="flex justify-center mt-3">
                    <Toggle
                        label="Show Financial Ratio"
                        onClick={() => setIsShow(!isShow)}
                        isChecked={isShow}
                    />
                </div>
            </div>
        </section>
    );
}

function RatioSection(props: {
    title: string,
    label: string[] | undefined,
    value: number[] | undefined,
    valueTitle: number
    chartType: "line" | "bar"
}) {


    const dataChart: MultipleChartData = {
        labels: ["", ...props.label || []],
        datasets: [
            {
                data: [0, ...props.value || []],
                backgroundColor: props.chartType === "bar" ? undefined : ["rgba(255, 165, 0, 0.2)"],
                borderColor: props.chartType === "bar" ? undefined : ["rgb(255, 165, 0)"],
                fill: true
            },
        ]
    }

    return (
        <div>
            <Card>
                <Card.Body>
                    <CardSection
                        label={props.title}
                        value={props.valueTitle}
                        icon={<PiWarningCircleFill />}
                    >
                        <div className="mt-[20px]">
                            <MultipleChart
                                chartType={props.chartType}
                                data={dataChart}
                            />
                        </div>
                    </CardSection>
                </Card.Body>
            </Card>
        </div>
    )
}